/**
 * Formata a data para o padrão 'dd/mm/aaaa'
 *
 * Esta função aceita uma string de data em vários formatos e a converte para o formato 'dd/mm/aaaa'.
 *
 * Formatos de entrada suportados:
 * - 'aaaa-mm-dd'
 * - 'aaaammdd'
 * - 'ddmmaaaa'
 * - 'dd.mm.aaaa'
 * - 'dd/mm/aaaa hh:mm'
 * - 'dd-mm-aaaa'
 * - 'dd/mm/aaaa'
 * - 'dd/mm/aa'
 * - 'aaaa/mm/dd'
 * - 'aaaa-mm-dd'
 *
 * @param {String} data - A string de data a ser formatada.
 * @returns {String} - A data formatada no padrão 'dd/mm/aaaa'. Retorna a string original se não corresponder a nenhum formato esperado.
 */
export function formatarData(data) {
    if (!data) return '-';

    const regexDataComHora = /^(\d{2})\/(\d{2})\/(\d{4}) \d{2}:\d{2}$/;

    if (regexDataComHora.test(data)) {
        return data.replace(regexDataComHora, '$1/$2/$3');
    }
    let cleanedData = data.replace(/\D/g, '');

    switch (cleanedData.length) {
        case 8:
            const mes = parseInt(cleanedData.substring(2, 4), 10);
            const ano = parseInt(cleanedData.substring(4, 8), 10);
            const anoMesValido =
                ano > 1900 && ano < 2100 && mes >= 1 && mes <= 12;

            return anoMesValido
                ? cleanedData.replace(/^(\d{2})(\d{2})(\d{4})$/, '$1/$2/$3')
                : cleanedData.replace(/^(\d{4})(\d{2})(\d{2})$/, '$3/$2/$1');

        case 6:
            return cleanedData.replace(/^(\d{2})(\d{2})(\d{2})$/, '$1/$2/20$3');
        default:
            return data;
    }
}

export default {
    formatarData
};
